import React, {useContext } from 'react';
import { AlertDialog, AlertDialogBody, AlertDialogCloseButton, AlertDialogContent, AlertDialogFooter, AlertDialogHeader, AlertDialogOverlay, Button, useDisclosure, useToast } from '@chakra-ui/react';
import { useParams, useNavigate } from "react-router-dom";
import ResponseHandler, {Responses} from './ResponseHandler';
import { dotNetError } from '../../models/dotnetDataModels';
import { UserContext } from '../../auth/Auth';
import { useFetch } from '../../contexts/FetchContext';
import ModalType from '../../models/endpointEnums';
import { useFormKeyBindings } from './useFormKeyBindings';
import { on } from 'events';

interface ModalProps {
    modalType: ModalType;
}

export const RestoreModal = ({modalType}: ModalProps) => {
    const restoreRef = React.useRef<HTMLButtonElement>(null);

    const user = useContext(UserContext);

    const navigate = useNavigate();

    const toast = useToast();

    const { id } = useParams();

    const {backend} = useFetch();

    const modalTypeFunction = (function () {
        switch(modalType) {
            case ModalType.ITEM:
                return () => backend.items.restore(parseInt(id!));
            case ModalType.MANUFACTURER:
                return () => backend.manufacturers.delete(parseInt(id!));
            case ModalType.LICENSE:
                return () => backend.licenses.delete(parseInt(id!));
        }
    })();

    const onClose = () => {
        navigate(-1);
    };

    const handleReturn = () => {
        if (user) {
            modalTypeFunction()
            .then(() => {
                ResponseHandler(`Sucessfully restored item 🤘`, Responses.Success, toast);
                onClose();
            }).catch((error: dotNetError) => {
                ResponseHandler(error.response.data.detail, Responses.Error, toast);
            })
        }
    }    

    return (
        <div>
            <AlertDialog
                motionPreset='slideInBottom'
                leastDestructiveRef={restoreRef}
                onClose={onClose}
                isOpen={true}
                isCentered
            >
                <AlertDialogOverlay/>

                <AlertDialogContent>
                    <AlertDialogHeader>Restore Item?</AlertDialogHeader>
                    <AlertDialogCloseButton/>

                    <AlertDialogBody>
                        Are you sure you want to restore this item?
                    </AlertDialogBody>

                    <AlertDialogFooter>
                        <Button colorScheme='grey' variant='ghost'  onClick={onClose}>Cancel</Button>
                        <Button colorScheme='green' ml={3} ref={restoreRef} onClick={handleReturn}>Restore</Button>
                    </AlertDialogFooter>
                </AlertDialogContent>
            </AlertDialog>
        </div>
    )
}
